<template>
    <div style="background-color:white;">
        <van-row style="padding:20px 20px 0px 20px;">
            <van-col span="12" style="text-align:left;">
                <img src="../../../assets/img/sany.png" style="height:41px;vertical-align:middle"/>
            </van-col>
            <van-col span="12" style="text-align:right;">
                <p style='color: red; font-size: 29px;font-weight:800;margin:0px;'>{{name}}</p>
            </van-col>
        </van-row>
        <p style='font-size: 24px;text-align: left;margin-left:20px;'>审计监察总部</p>
        <div width='100%' style="height:2px;width:100%;background-color:red;"></div>
        <!-- <div v-html="form.reportContent" style="padding:20px 10px;"></div> -->
        <!-- <MyEditor :valueHtml="form.reportEmailContent" :heights="true" class="article" /> -->
        <MyEditor :valueHtml="form.reportContent" :heights="true" class="article" style="padding-bottom:20px;" :selectDisabled="true"/>
    </div>
    
</template>
<script>
import MyEditor from "@/plugins/myEditor"
export default {
    components:{
        MyEditor
    },
    data(){
        return {
            name:'',
            curUserNo:'',
            form:{},
            reportTypes:{
                '1':'风险通报',
                '2':'问责通报'
            }
        }
    },
    created(){
        this.curUserNo = this.$userNo()
        document.title='通报'
        this.initData()
    },
    mounted(){
    },
    methods:{
        initData(){
            let guid = this.$route.query.guid
            this.$http.get('/api/job/v0.1/riskReport/getViewByGuid?guid='+guid)
            .then(res=>{
                if(res.data.reportContent){

                }
                if("1"==res.data.reportType){
                    this.name = "风险提示函";
                }else if("2"==res.data.reportType){
                    this.name = "问责通报";
                }
                this.form = res.data
                document.title = this.reportTypes[res.data.reportType]
            })
        },

        replace_html_tag_style(src_str,tag,attr,val){
            if(!src_str){
            return
            }
            var reg = new RegExp("<"+tag+"[ |>][^>]*>",'gi');
            return src_str.replace(reg,(match)=>{
            if(match.indexOf(attr)>-1){
                return match
            }
            if(match.indexOf(' style="')>0){
                return match.replace(' style="',' style="'+attr+":"+val+';')
            }else if(match.indexOf(' style=\'')>0){
                return match.replace(' style=\'',' style=\''+attr+":"+val+';')
            }else{
                return match.replace('<'+tag,'<'+tag+' style=\''+attr+":"+val+';\'')
            }
            })
        }
    }
}
</script>